import React, { Component } from 'react'
import shallowCompare from 'shallow-compare'
import ReactMarkdown from 'react-markdown'
import hljs from '../util/highlight.js'
import { Link as AppLink } from '../components/index.js'

const InlineCodeBlock = props => {
  return (
    <code>{props.value}</code>
  )
}

class CodeBlock extends Component {
  shouldComponentUpdate = (nextProps, nextState) => {
    return shallowCompare(this, nextProps, nextState)
  }

  componentDidMount () {
    this.highlightCode()
  }

  componentDidUpdate () {
    this.highlightCode()
  }

  highlightCode () {
    hljs.highlightBlock(this.code)
  }

  render () {
    return (
      <pre>
        <code ref={(el) => { this.code = el }} className={this.props.language}>{this.props.value}</code>
      </pre>
    )
  }
}

class Link extends Component {
  shouldComponentUpdate = (nextProps, nextState) => {
    return shallowCompare(this, nextProps, nextState)
  }

  render () {
    return (
      <AppLink to={this.props.href} external={!isHrefInternal(this.props.href)} title={this.props.title}>{this.props.children}</AppLink>
    )
  }
}

const isHrefInternal = href => href.indexOf('/') === 0 ||
  (window && window.location && window.location.origin && href.indexOf(window.location.origin) === 0)

export default class Markdown extends Component {
  static defaultProps = {
    allowHtml: false
  }
  render () {
    let { allowHtml } = this.props
    let renderers = this.props.renderers || {}
    return <div className='markdown-container'>
      <ReactMarkdown source={this.props.source || ''}
        escapeHtml={!allowHtml}
        renderers={{code: CodeBlock, inlineCode: InlineCodeBlock, link: Link, ...renderers}}
      />
    </div>
  }
}



// WEBPACK FOOTER //
// ./client/src/components/Markdown.js